import React from 'react';

import CarrinhoPage from '../../components/Carrinho';

function Carrinho() {
  return <CarrinhoPage />;
}

export default Carrinho;